import * as React from "react";
import { Icon } from "sb-resp-ui";

export class Place extends React.Component<{ label: string, hasLiveStream?: boolean }, {}> {
    render() {
        return (
            <div className="rj-racing-current-races__place">
                <div className="rj-racing-current-races__league">
                    {this.props.label}
                </div>
                {this.props.hasLiveStream && (
                    <div className="rj-racing-current-races__right-panel">
                        <Icon i="i-24-16 i-o-ev-streaming" />
                    </div>
                )}
            </div>
        )
    }
}